import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import StockTransferItem from "./StockTransferItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import PaginatorButton from "../../../components/PaginatorButton";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {LIST_STOCK_TRANSFERS, ON_STOCK_TRANSFER_UPDATED} from "../../../queries/stockTransfers";

class StockTransfersList extends Component {

  componentDidMount() {
    this.subscribe();
  }

  subscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToUpdates(this.props, {});
  }

  render() {
    let {loading, error, stockTransfers} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = List([
      "Transfer #",
      "Purchase Order",
      "Origin",
      "Destination",
      "Type",
      "Carrier Reference",
      "Expected",
      "Status",
    ])
    let stockTransfersData = fromJS(stockTransfers);
    return (
      <div>
        <Table
          data={stockTransfersData.get("entries")}
          renderer={StockTransferItem}
          onItemClick={this.handleItemClick.bind(this)}
          tableHeader={tableHeader}
          extraClassName="StockTransfersList"
          itemKey="id"
          mode="table"
          showCount={true}
          />
        <PaginatorButton
          metadata={stockTransfersData.get("metadata")}
          onNext={this.handleNext.bind(this)}
          />
      </div>
    )
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          stockTransfers: {
            __typename: prev.stockTransfers.__typename,
            metadata: fetchMoreResult.stockTransfers.metadata,
            entries: [...prev.stockTransfers.entries, ...fetchMoreResult.stockTransfers.entries]
          }
        }
      }
    })
  }

  handleItemClick(itemData, e, field = "") {
    this.props.onSelectionChange(itemData.get("id"));
  }
}

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_STOCK_TRANSFER_UPDATED,
      updateQuery: (prev, {subscriptionData}) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(LIST_STOCK_TRANSFERS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        status: props.statusFilter,
        originWarehouseId: props.originFilter,
        destinationWarehouseId: props.destinationFilter,
      }
    }
  })
})

export default withQuery(withSubscription(StockTransfersList));
